export const BOT_DEVICE_ID = "bot";
